<script setup lang="ts">
import { computed } from 'vue'

import { useDarkMode } from '@/composables/useDarkMode'
import UiIcon from '@/components/common/UiIcon.vue'

const { isDark, toggleDark } = useDarkMode()

const label = computed(() =>
  isDark.value ? 'Switch to light mode' : 'Switch to dark mode',
)
</script>

<template>
  <button
    type="button"
    class="utility-trigger utility-trigger--icon p-2"
    :aria-label="label"
    :aria-pressed="isDark ? 'true' : 'false'"
    @click="toggleDark"
  >
    <span
      class="inline-flex items-center justify-center overflow-hidden"
      aria-hidden="true"
    >
      <Transition
        name="theme-toggle-icon"
        mode="out-in"
      >
        <UiIcon
          v-if="!isDark"
          key="sun"
          name="Sun"
          class="size-6"
        />
        <UiIcon
          v-else
          key="moon"
          name="Moon"
          class="size-6"
        />
      </Transition>
    </span>
  </button>
</template>
